import { render, staticRenderFns } from "./info.vue?vue&type=template&id=fbf7acba&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=fbf7acba&prod&lang=css"
import style1 from "./info.vue?vue&type=style&index=1&id=fbf7acba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf7acba",
  null
  
)

export default component.exports